import { Button } from "@/components/ui/button";
import { DialogClose } from "@/components/ui/dialog";
import { CheckCircle } from "lucide-react";

export function Success() {
    return (
        <div className="pt-6">
            <div className="flex items-center justify-center">
                <CheckCircle className="size-10" />
            </div>
            <h2 className="mt-4 text-center font-bold text-2xl">Transaction Successful</h2>
            <div className="mt-2 text-center text-muted-foreground">
                Your transaction has been completed successfully.
            </div>

            <DialogClose asChild>
                <Button className="mt-8 w-full">Close</Button>
            </DialogClose>
        </div>
    );
}
